import { Component, OnInit, OnDestroy, ErrorHandler, Output, Input, EventEmitter, ViewChildren, QueryList, AfterViewInit, ElementRef  } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { Location } from '@angular/common';
import { EwalletListService } from '../../../data/service/ewalletList.service';
import { JwtService } from '../../../data/service/jwt.service';
import { CouponInstanceModel } from '../../../data/models/couponInstance.model';
import { CustomerInfoModel } from '../../../data/models/customerInfo.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrMsgUtil } from '../../../data/util/errMsgUtil';
import { PopupMsgUtil } from '../../../data/util/popupMsgUtil';
import { JwtUtil } from '../../../data/util/jwtUtils';
import { LoginModel } from '../../../data/models/login.model';
import { ErrHandler } from '../../../data/util/errHandler';
import { ComponentUtil } from '../../../data/util/componentUtil';
import { CouponListCommonUtil } from '../../../data/util/couponListCommonUtil';
import { FavroitesService } from '../../../data/service/favroites.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { InfiniteScroll } from 'angular2-infinite-scroll';

interface CouponInstanceModelWithIndex extends CouponInstanceModel {
  index: number;
}

@Component({
  selector: 'app-myewallet-evouchers',
  templateUrl: './myewallet-eVoucher.component.html',
  styleUrls: ['./myewallet-eVoucher.component.scss']
})
export class MyEwalleteVoucherComponent implements OnInit {
  /**api use data */
  couponList: CouponInstanceModel[] = [];//page use result list
  allCouponList: CouponInstanceModel[] = [];//api return result list
  resultBrandMap: Map<string, number> = new Map<string, number>();//api return get the exist brand

  issueBrandList: string[] = [];

  /** filter variable */
  filterBrand: string;
  filterStatus: string;
  // filterType:string;
  // filterCouponName:string;

  /** touch event variable */
  touchStartY: number;
  touchEndY: number;

  /** component event variable */
  @Output()
  qrCode = new EventEmitter<any>();

  @Output()
  share = new EventEmitter<any>();

  @Output()
  popDetail = new EventEmitter<any>();

  @Input() activeTab: string;

  /** page flag  */
  showCouponList: boolean = false;//not data show flag
  channel: string;
  appIssueBrand: string;
  favoritesString: string;
  is1010Home: boolean;

  /** storage use key*/
  private brandFilterKey: string = "myWallet_coupon_brands_filter";
  private typeFilterKey: string = "myWallet_type_filter";
  private statusFilterKey: string = "myWallet_coupon_status_filter";
  private nameFilterKey: string = "myWallet_name_filter";

  /**split page pram */
  // defaultLimit: number = environment.couponPageLimit;
  defaultLimit: number = 20;
  nextOffset: number = 0;
  totalNumber: number = 0;
  currentY: number = 0;
  env = environment;
  dateFormat: string;
  isWeb: boolean;
  scrollLock: boolean;

  currentTab: string = 'myewallet-evouchers';

  closeSrc: string;

  redemptionRecordPageBgColor: string = '';

  specifiedCpnItem = (() => {
    const item = sessionStorage.getItem('couponItem');
    return item ? item.toUpperCase() : '';
  })();
  isSpecifiedCpnItemExist: boolean = false;
  isSpecificCpnItemNotFoundPopupVisible: boolean = false;
  isRealStatusChange: boolean = true;
  
  constructor(private router: Router, private ewalletListService: EwalletListService, private jwtService: JwtService
    , private location: Location, private errMsgUtil: ErrMsgUtil, private jwtUtil: JwtUtil, private translateService: TranslateService, private popupMsgUtil: PopupMsgUtil, private favroitesService: FavroitesService, private componentUtil: ComponentUtil,) { }


  ngOnInit() {
    this.channel = this.jwtUtil.getSubServiceAppType();
    this.appIssueBrand = this.jwtUtil.getIssueBrandFromServiceAppType();
    // var sv=document.getElementsByClassName('couponScrollFreshView')[0];
    // sv.addEventListener("touchstart",this.onTouchStart,false);
    // sv.addEventListener("touchend",this.onTouchEnd,false);
    this.favoritesString = '';
    this.translateService.get("momentDateFormat").subscribe(
      (res) => {
        this.dateFormat = res;
      }
    );
    // if(this.currentTab == this.activeTab){
    //   this.initDetail();
    // }
    this.is1010Home = sessionStorage.getItem('style') == '1010myhkt';
    this.closeSrc = this.jwtUtil.getClosePng();
    if(this.channel == '1010' || (this.channel == 'MyHKT' && this.is1010Home)){
      this.redemptionRecordPageBgColor = 'rgb(36, 35, 34)';
      // this.redemptionRecordPageBgColor = 'white';
    }else if(this.channel == 'csl'){
      this.redemptionRecordPageBgColor = '#efefef';
    }
  }

  @ViewChildren('couponLists') items!: QueryList<ElementRef>;
  ngAfterViewInit() {
    this.items.changes.subscribe(() => {
      if (this.items.length > 0 && this.specifiedCpnItem) {
        const specifiedCoupon: CouponInstanceModelWithIndex = CouponListCommonUtil.findSpecifiedCouponItem(this.couponList, this.specifiedCpnItem);
        if(specifiedCoupon.index != -1){
          let specifiedIndex = specifiedCoupon.index;
          const items = this.items.toArray();
          const element = items[specifiedIndex].nativeElement;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - 130;
          let specifiedConponCode = specifiedCoupon.couponAlias?specifiedCoupon.couponAlias:specifiedCoupon.couponItem!.couponItemCode
          setTimeout(() => {
            window.scrollBy({ top: offsetPosition, behavior: 'smooth' });
            if(this.specifiedCpnItem && specifiedCoupon) document.getElementById('btn-'+specifiedConponCode)?.click();
            this.isSpecifiedCpnItemExist = false;
            this.specifiedCpnItem = '';
          }, 300); 
        }
      } 
    });
  }

  close() {
    this.isSpecificCpnItemNotFoundPopupVisible = false;
  }

  onConfirm() {
    this.close();
  }

  init() {
    console.log("couponList init")
    var sbf = sessionStorage.getItem(this.brandFilterKey);
    // var stf=sessionStorage.getItem(this.typeFilterKey);
    var ssf = sessionStorage.getItem(this.statusFilterKey);
    // var snf=sessionStorage.getItem(this.nameFilterKey);

    if (!ComponentUtil.checkSelectNotNull(ssf)) {
       sessionStorage.setItem(this.statusFilterKey,"REDEEMABLE");
       ssf="REDEEMABLE";
      // sessionStorage.setItem(this.statusFilterKey, "REDEEMABLE,REDEEMED");
      // ssf = "REDEEMABLE,REDEEMED";
    }
    console.log("session brand:" + sbf + ";type:" + null + ";status:" + ssf + ";name:" + null);
    this.filterBrand = sbf;
    // this.filterType=stf;
    this.filterStatus = ssf;
    this.scrollLock = false;
    // this.filterCouponName=null;
    this.isWeb = localStorage.getItem('env') ? localStorage.getItem('env') == 'web' : false;
    const _this = this;
    this.initDetail();
    //  ErrMsgUtil.popupToken(this.jwtUtil.getServiceAppToken());
  }

  initDetail() {
    this.resultBrandMap.clear();
    this.allCouponList = [];
    this.couponList = [];
    this.showCouponList = false;
    if(this.specifiedCpnItem){
      this.searchCouponListNewWithSpecifiedCpnItem();
    }else{
      this.searchCouponListNew(0, this.defaultLimit, this.filterBrand, true, this.filterStatus, (this.filterStatus == 'All' || this.filterStatus.indexOf('REDEEMABLE') > -1) ? true : false, false);
    }
  }

 searchCouponListNewWithSpecifiedCpnItem() {
    let couponStatus = 'All';
    let category = 'C';
    this.popupMsgUtil.loading();
    const getList = async (offsetCall: number) => {
        combineLatest(
          this.ewalletListService.getCouponList(category, offsetCall, 1000, this.filterBrand, couponStatus, true, false)
        ).subscribe(([res]) => {
            res = this.jwtUtil.setupResponse(res);
            res = res.data;
            res = CouponListCommonUtil.setDayOffAndSort(res, this.resultBrandMap, this.dateFormat);
            this.updateBrandList();
            this.allCouponList = this.allCouponList.concat(res);
            let filterList = CouponListCommonUtil.removeDuplicateCoupon(this.allCouponList);
            let statusMap = CouponListCommonUtil.filterStatusList(filterList, category);
            let targetStaus = this.checkSpecifiedCpnItem(statusMap);
            this.couponList =  CouponListCommonUtil.sortCouponList(statusMap[targetStaus]);
            this.isRealStatusChange = false;
            this.statusChange(targetStaus);
            if(this.isSpecifiedCpnItemExist){
              if (this.currentY > 0) {
                window.scroll(0, this.currentY);
                this.currentY = 0;
              }
            }else{
              console.log('no item - ' + this.specifiedCpnItem);
              this.isSpecificCpnItemNotFoundPopupVisible = true;
            }
            this.showCouponList = true;
            this.scrollLock = false;
            this.popupMsgUtil.endLoading();
            this.isRealStatusChange = true;
            sessionStorage.removeItem('couponItem');
          }, (err) => {
          this.showCouponList = true;
          this.popupMsgUtil.endLoading();
          this.scrollLock = false;
          const _this = this;
          function getHandler(): ErrHandler {
            let handler = <ErrHandler><unknown>function () { };
            handler.handleErr = function () {

            }
            handler.handleRefreshToken = function () {
              _this.initDetail();
            }
            return handler;
          }
          var eh: ErrHandler = getHandler();
          this.errMsgUtil.handleErr(eh, err.error);
        })
    };
    getList(0);
    // const res = await this.ewalletListService.getCouponList(category, 0, 1000, this.filterBrand, couponStatus, true, false).toPromise();
    // const setupRes = this.jwtUtil.setupResponse(res);
    // let filterList = CouponListCommonUtil.filter90DayAnd3rdPartyCoupon(setupRes.data, couponStatus, category);
    // console.log(filterList);
  }

  checkSpecifiedCpnItem(statusMap: any): string {
    let returnStatus = 'REDEEMABLE';
    let found = false;
    Object.keys(statusMap).forEach(key => {
      if(found) return;
      if(statusMap[key].length > 0){
        statusMap[key].forEach((instance: CouponInstanceModel) => {
          if(instance.couponItem?.couponItemCode == this.specifiedCpnItem){
            this.isSpecifiedCpnItemExist = true;
            returnStatus = key;
            found = true
          }
        });
      }
    });
    return returnStatus;
  }

  goDetail(id: string, itemId: string) {
    var a = { 'couponId': id, 'couponItemId': itemId, 'page': 'coupon' }
    this.popDetail.emit(a);
  }

  /* component method  start */
  //1 search bar
  searchCouponForCouponName() {
    //     var sbf=sessionStorage.getItem("myWallet_brand_filter");
    //     var stf=sessionStorage.getItem("myWallet_type_filter");
    //     var ssf=sessionStorage.getItem("myWallet_status_filter");
    //     // var snf=sessionStorage.getItem("myWallet_name_filter");
    //     this.filterBrand=sbf;
    //     // this.filterType=stf;
    //     this.filterStatus=ssf;
    //     // this.filterCouponName=snf;
    //     var sc=document.getElementById('searchCoupon');
    //     console.log(sc);
    //     this.filterCouponName=sc.getAttribute('ng-reflect-model');
    //     if(!this.filterCouponName||this.filterCouponName==''){
    //        this.filterBrand=null;
    //        this.clickCouponStatus('All');
    //        sessionStorage.removeItem("myWallet_brand_filter");
    //        sessionStorage.removeItem("myWallet_status_filter");
    //     }     
    //     // this.filterResult(this.filterBrand,this.filterStatus,this.filterType,this.filterCouponName);
    //     this.couponList=CouponListCommonUtil.filterResult(this.allCouponList,this.filterBrand,this.filterStatus,this.filterType,this.filterCouponName);
  }

  //2 brand filter
  brandChange(event) {
    var brand = event;
    sessionStorage.setItem(this.brandFilterKey, brand);
    this.nextOffset = 0;
    var status: string = sessionStorage.getItem(this.statusFilterKey);
    this.searchCouponListNew(this.nextOffset, this.defaultLimit, brand, true, status, (status == 'All' || status.indexOf('REDEEMABLE') > -1) ? true : false, false);
    this.jwtUtil.setupSessionTime();
  }

  //3 status filter
  statusChange(event) {
    var status: string = event;
    this.filterStatus = status;
    sessionStorage.setItem(this.statusFilterKey, status);
    var brand: string = sessionStorage.getItem(this.brandFilterKey);
    if(this.isRealStatusChange){
      this.showCouponList = false;
      this.nextOffset = 0;
      this.searchCouponListNew(this.nextOffset, this.defaultLimit, brand, true, status, (status == 'All' || status.indexOf('REDEEMABLE') > -1) ? true : false, false);
      this.jwtUtil.setupSessionTime();
    }
  }


  //5 name card event +
  clickQrCode() {
    this.qrCode.emit();
  }

  clickShare() {
    console.log(1);
    this.share.emit();
  }

  clickRedemptionRecords() {
    document.getElementById('myewalletevouchers-redemptionRecords').click();
  }
  //5 name card event -

  //6 favorite 
  getFavorites() { //by coco:get favorites coupon from backend
    var status: string = sessionStorage.getItem(this.statusFilterKey);
    this.favroitesService.getFavoritesList("91234568").subscribe(
      (res) => {
        res = this.jwtUtil.setupResponse(res);
        console.log('favorites:' + JSON.stringify(res.favourites));
        this.favoritesString = JSON.stringify(res.favourites);
        this.favoritesString = this.favoritesString.replace(/"/g, '');
        this.favoritesString = this.favoritesString.replace('null', '');
        if (this.couponList) {
          this.couponList = CouponListCommonUtil.filterResultWithFavriotes(this.couponList, status, this.favoritesString);
        }
      }
      , (err) => {
        this.popupMsgUtil.endLoading();
        const _this = this;
        function getHandler(): ErrHandler {
          let handler = <ErrHandler><unknown>function () { };
          handler.handleErr = function () {

          }
          handler.handleRefreshToken = function () {
            _this.getFavorites();
          }
          return handler;
        }
        var eh: ErrHandler = getHandler();
        this.errMsgUtil.handleErr(eh, err.error);
      }
    );
  }

  //7.update the favoritesString from the child component and change the coupon list data.  
  fromChildFunc(data) {
    //console.log('on click data:'+data);
    this.favoritesString = data;
    // this.couponList=CouponListCommonUtil.filterResult(this.allCouponList,this.filterBrand,this.filterStatus,null,null);
    // if(this.couponList){
    //   this.couponList=CouponListCommonUtil.filterResultWithFavriotes(this.couponList,this.filterStatus,this.favoritesString);
    // }
  }


  searchCouponListNew(offset: number, limit: number, brand: string, reset: boolean, status: string, hasPromotional: boolean, hasSpringboard: boolean) {
    if (reset) {
      // this.resultBrandMap.clear();
      this.allCouponList = [];
      this.couponList = [];
    }
    this.popupMsgUtil.loading();
    const category = 'C';
    if(status == 'REDEEMABLE'){
      status = 'REDEEMABLE,REDEEMED';
    }
    const getList = (offsetCall: number) => {
      combineLatest(
        this.ewalletListService.getCouponList(category, offsetCall, limit, brand, status, hasPromotional, hasSpringboard),
      ).subscribe(
        ([res]) => {
          res = this.jwtUtil.setupResponse(res);
          this.totalNumber = res.totalNumber;
          res = res.data;
          res = CouponListCommonUtil.setDayOffAndSort(res, this.resultBrandMap, this.dateFormat);
          this.updateBrandList();
          this.allCouponList = this.allCouponList.concat(res);
          this.nextOffset = offsetCall + limit;
          let filterList = CouponListCommonUtil.filter90DayAnd3rdPartyCoupon(this.allCouponList, status, category);
          filterList = CouponListCommonUtil.removeDuplicateCoupon(filterList);
          // if list is not enough and have not requested yet, call searchCoupon api
          if (filterList.length - this.couponList.length < limit && this.allCouponList.length < this.totalNumber) {
            getList(this.nextOffset);
          } else {
            this.couponList = CouponListCommonUtil.sortCouponList(filterList);
            this.showCouponList = true;
            if (this.currentY > 0) {
              window.scroll(0, this.currentY);
              this.currentY = 0;
            }
            this.scrollLock = false;
            this.popupMsgUtil.endLoading();
          }
        }
        , (err) => {
          this.showCouponList = true;
          this.popupMsgUtil.endLoading();
          this.scrollLock = false;
          const _this = this;
          function getHandler(): ErrHandler {
            let handler = <ErrHandler><unknown>function () { };
            handler.handleErr = function () {

            }
            handler.handleRefreshToken = function () {
              _this.initDetail();
            }
            return handler;
          }
          var eh: ErrHandler = getHandler();
          this.errMsgUtil.handleErr(eh, err.error);
        }
      );
    }

    getList(offset);
  }

  moreCoupon() {
    var brand: string = sessionStorage.getItem(this.brandFilterKey);
    var status: string = sessionStorage.getItem(this.statusFilterKey);
    if (this.allCouponList.length > 0 && this.totalNumber > this.nextOffset) {
      this.currentY = window.scrollY;
      this.searchCouponListNew(this.nextOffset, this.defaultLimit, brand, false, status, false, false);
    }
    else {
      this.scrollLock = false;
    }
  }
  openPromoCpnDetail(item: any) {
    var a = { 'couponId': item.couponCode, 'couponItemId': item.couponItem.couponItemCode, 'page': 'coupon', isFromPromotional: true, sourceTab: 'myewallet-evouchers' };
    this.popDetail.emit(a);
  }

  updateBrandList() {
    if (this.resultBrandMap.size > 0) {
      var temp = [];
      for (const [key, value] of this.resultBrandMap.entries()) {
        if (key) {
          temp.push(key);
        }
      }
      this.appIssueBrand = this.jwtUtil.getIssueBrandFromServiceAppType();
      if (this.appIssueBrand && temp.length > 0) {
        var appIssueBrand = this.appIssueBrand.toLowerCase();
        temp.sort(function (x, y) { return x.toLowerCase().includes(appIssueBrand) ? -1 : y.toLowerCase().includes(appIssueBrand) ? 1 : 0; });
        if (appIssueBrand == '1010') {
          appIssueBrand = '1o1o';
          temp.sort(function (x, y) { return x.toLowerCase().includes(appIssueBrand) ? -1 : y.toLowerCase().includes(appIssueBrand) ? 1 : 0; });
        }
      }
      this.issueBrandList = temp;
    }
  }
}
